import { render, staticRenderFns } from "./TweetItem.vue?vue&type=template&id=5b352b56&"
import script from "./TweetItem.vue?vue&type=script&lang=js&"
export * from "./TweetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports